module.exports = __webpack_public_path__ + "img/2.4bc6e7e3.png";